import * as React from "react";
function SvgTagCog(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M31 20.5a.52.52 0 00-.7-.23s-.68.17-1.62.43a5.45 5.45 0 00-1.51-1c-.14-1-.26-1.66-.26-1.66a.52.52 0 00-.49-.55l-2.07-.12a.52.52 0 00-.54.49s-.2.67-.44 1.62a5.93 5.93 0 00-.84.34 5.48 5.48 0 00-.77.47c-.91-.36-1.56-.6-1.56-.6a.52.52 0 00-.72.15l-1.13 1.73a.52.52 0 00.15.72s.48.5 1.18 1.19a5.45 5.45 0 00-.1 1.8c-.77.6-1.31 1-1.31 1a.52.52 0 00-.23.7l.96 1.91a.52.52 0 00.7.23s.68-.17 1.62-.43a5.45 5.45 0 001.51 1c.14 1 .26 1.66.26 1.66a.52.52 0 00.49.55l2.07.12a.52.52 0 00.54-.49s.2-.67.44-1.62a5.94 5.94 0 00.84-.34 5.48 5.48 0 00.77-.47c.91.37 1.56.6 1.56.6a.52.52 0 00.72-.15l1.13-1.73a.52.52 0 00-.15-.72s-.48-.5-1.18-1.19a5.45 5.45 0 00.1-1.8c.77-.6 1.31-1 1.31-1a.52.52 0 00.23-.7zm-4.16 3.26a2.07 2.07 0 11-2.78-.92 2.07 2.07 0 012.79.92z" />
      <path
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M14.96 31H4.1L2.04 20.57 17.04 2l12.91 10.43-2.01 2.5"
      />
      <path d="M9.83 22.5a1 1 0 11-1 1 1 1 0 011-1m0-2a3 3 0 103 3 3 3 0 00-3-3z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTagCog);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
